

import Vue from 'vue';
import userChangeEmailDialogVue from './UserChangeEmailDialog.vue';
import userChangePhoneDialogVue from './UserChangePhoneDialog.vue';

export const UserChangeEmailDialog = userChangeEmailDialogVue;
export const UserChangePhoneDialog = userChangePhoneDialogVue;

export class IndexComponent{
    public static register() {
        Vue.component('user-change-email-dialog', userChangeEmailDialogVue);
        Vue.component('user-change-phone-dialog', userChangePhoneDialogVue);
    }
}